import React from 'react'
import {RadioGroup as DefaultRadioGroup} from 'react-radio-group'
import {RadioGroupView} from './RadioStyles'

const RadioInput = props => <DefaultRadioGroup {...props} Component={RadioGroupView} />

export default RadioInput
